import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe491619"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-principles-screen",
  role: "presentation"
}
const _hoisted_2 = {
  ref: "panelEl",
  class: "nge-principles-panel",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "nge-principles-title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-principles-kicker" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-principles-dot",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode("Retina dataset")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "nge-principles-title",
  class: "nge-principles-title"
}, "The Eyewire II Principles", -1 /* HOISTED */))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "nge-principles-error",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("p", { class: "nge-principles-text" }, [
              _createTextVNode("The retina is shared with the Eyewire II community before it is published, so please keep what you find here within the community and respect each other's work. "),
              _createElementVNode("a", {
                href: $setup.PRINCIPLES_URL,
                target: "_blank",
                rel: "noopener noreferrer"
              }, "Read the principles")
            ]),
            _createElementVNode("button", {
              class: "nge-principles-btn",
              disabled: $setup.sending,
              onClick: $setup.agree
            }, _toDisplayString($setup.sending ? 'Saving...' : 'OK, I agree'), 9 /* TEXT, PROPS */, _hoisted_5),
            ($setup.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.error), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], 512 /* NEED_PATCH */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}